import React from "react";
import * as style from "./FeatureGroup.module.scss";
import { Box } from "@mui/material";
import {
  TextInput,
  TextArea,
  Divider,
  Toggle,
} from "cprime-foundational-components";
import Typography from "../../Components/Common/CprimeText";

interface AddApplicationContentProps {
  setFormValue: any;
  formValue: any;
}

const FeatureGroupSidebarContent: React.FC<AddApplicationContentProps> = ({
  setFormValue,
  formValue,
}) => {
  const scssClass = style as any;

  return (
    <div
      className={scssClass.panelContent}
      style={{ height: `calc(100vh - 14.85rem)` }}
    >
      <Divider
        variant={"fullWidth"}
        sx={{
          marginBottom: "15px",
          width: "100%",
          marginLeft: "0px !important",
          backgroundColor: "#f8f8f9 !important",
        }}
      />
      <Typography className={scssClass.textDescription}>
        Feature Group Details
      </Typography>
      <div className={scssClass.fieldsContent}>
        <TextInput
          value={formValue?.name}
          className={scssClass.textField}
          style={{ width: "100%" }}
          onChange={(e: any) => {
            setFormValue("name", e?.target?.value);
            // nameValueStream(e?.target?.value);
          }}
          placeholder="Enter Name"
          label="Feature Group Name"
        />
        <TextArea
          label="Description"
          aria-label="minimum height"
          minRows={3}
          placeholder="Enter Description"
          style={{ width: "99.5%" }}
          value={formValue?.description}
          onChange={(e) => {
            setFormValue("description", e?.target?.value);
            // descriptionValueStream(e?.target?.value);
          }}
          maxLength={500}
        />
        <Box width="100%">
          <Box>
            <Toggle
              checked={formValue?.isVisible}
              label="Visible to Users"
              size="small"
              toggledText={formValue.isVisible ? "On" : "Off"}
              sx={{
                overflow: "visible",
                marginBottom: "4px",
                "& .MuiSwitch-thumb": {
                  marginTop: "4px",
                },
              }}
              // data-testid={`set-status-${permission?.permission_id}`}
              onChange={() => {
                setFormValue("isVisible", !formValue?.isVisible);
              }}
            />
          </Box>
        </Box>
      </div>
    </div>
  );
};
export default FeatureGroupSidebarContent;
